import React from "react";
import QuizForm from "components/QuizForm/quizForm";

export default function AddQuiz() {
  return (
    <div className="add-quiz-page">
      <QuizForm />
    </div>
  );
}